import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage-angular";
import { BaseStorageRepository } from "./abstract/base.storage.repository";
import { RequestData } from "../types/Request/RequestData";

@Injectable({
  providedIn: "root",
})
export class RequestRepository extends BaseStorageRepository<RequestData> {
  constructor(storage: Storage) {
    super(storage, "requestData");
  }
}
